import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IEditSupportUserProfileClient,
} from 'interfaceAdapter/gatewaySchemas/IEditSupportUserProfileClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

const PATH = `${API_LOCATION_URL}/supporter/edit/user_profile`;

export class EditSupportUserProfileClient implements IEditSupportUserProfileClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, support_user } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify(support_user);

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
